<template>
  <div class="rep-list">
    <div class="dn-top">
      <div class="dp1">报告下载</div>
      <div class="dp2">请选择您需要查看/下载的报告信息</div>
    </div>

    <div class="dn-bot">

      <div class="dp-xia">

        <p v-for="(item,index) in reportInfo" :key="index">
          <a :href=item.file class="a-big">{{item.commodity_name}} <b>点击下载</b></a>
        </p>
      </div>

    </div>

  </div>
</template>
<script>

   export default {
      data() {
         return {
            report_id: this.$route.params.report_id,
            report_type: this.$route.params.report_type,
            // result: this.$route.params.result,
            reportInfo: [],

         }
      },
      methods: {

         loadpage() {
            console.log(this.result)
            // this.$http.api.findReport_id({ ///api/report/findPhone

            this.$http.api.findOnlyreport2({
               phone: this.report_id,
               type: this.report_type
            }).then(result => {
               this.reportInfo = result.rows
               console.log('reportInfo:', this.reportInfo)
            })



         },

         toDetail(val) {
            this.$router.push({
               name: 'reportDetail',
               params: {
                  phone: val
               }
            })
         },
      },
      created() {
         this.loadpage()
      },
      mounted() {

      }
   }
</script>
<style scoped>
  .rep-list {
    background: #ffffff;
    margin: 0 auto ;
    width: 96%;
    padding: 0.6rem 0 1.2rem;
  }

  .dn-top {
    text-align: center;
    padding: 0 0 1rem;
  }

  .dn-top .dp1 {
    font-size: 0.5rem;
    color: #000000;
  }

  .dn-top .dp2 {
    font-size: 0.4rem;
    color: #333333;
    margin: 0.2rem 0 0;
  }

  .dn-bot {
    border: 1px solid #cccccc;
    width: 90%;
    margin: auto;

  }



  .dn-bot .dp-xia {
    padding: 0.1rem 0.4rem;
    line-height: 1.2rem;

    font-size: 0.36rem;

  }

  .dn-bot .dp-xia p:not(:last-of-type) {
    border-bottom: 1px dashed #cccccc;
  }

  .dn-bot .dp-xia p b {
    float: right;
    font-size: 0.32rem;
    color: #61B0E3;
  }
</style>


